<template>
  <div class="container">
    <a href="http://www.neumomed.com">
      <img class="logo" draggable="false" src="../assets/logo-neumomed.png">
    </a>
    <div class="contenido">
      <h2 class="titulo1">Bienvenido a la</h2>
      <h1 class="titulo2">Historia Clínica de Neumomed</h1>
      <p
        class="parrafo"
      >El Asistente Virtual te acompaña paso a paso en el registro clínico de nuestros pacientes, haciendo este proceso más rápido y sencillo.</p>
      <LoginGoogle />
    </div>
    <img id="vpTest" class="imagen" src="../assets/esquina.png" />
    <img class="static_neumobot" src="../assets/neumobot.png" />
  </div>
</template>

<script>
import { serverBus } from "../main";
import { mapMutations } from "vuex";
import axios from "../apiService/config/axios.js";
import LoginGoogle from '../components/Login/Login';

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: ""
    };
  },
  components: {
    LoginGoogle
  },
  methods: {
    validation: function(event) {
      axios
        .post("/apoyo_7x24_backend/users/login", {
          username: this.username,
          password: this.password
        })
        .then(response => {
          this.user = this.username;
          // setTimeout(() => serverBus.$emit('validation',this.user,1000))
          // this.$emit("validation",this.username)
          // this.$store.state.userloged = this.username;
          this.$store.dispatch("saveUserLogged", this.username);
          this.$store.dispatch("saveUser", response.data.data.nombre);
          this.$store.dispatch(
            "saveProviderId",
            response.data.data.provider_id
          );
          this.$router.replace(this.$route.query.redirect || "/soporte");
        })
        .catch();
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Nunito:400,600&display=swap");
.container {
  background-image: url(../assets/fondo.png);
  margin: 0;
  padding: 0; /* Para quitar un padding de 15px a los lados*/
  max-width: 100%;
  width: 100%;
  height: 100%;
}

.logo {
  width: 6vw;
  margin: 2.87vh 2vw;
}

.contenido {
  user-select: none;
  padding-left: 9vw;
  margin: auto;
  position: absolute;
  top: 32vh;
}

.titulo1 {
  font-family: Nunito, sans-serif;
  font-weight: 400;
  font-size: 2.5vw;
  color: #646a6a;
  margin: 0;
}

.titulo2 {
  font-family: Nunito, sans-serif;
  font-weight: 600;
  font-size: 3.4vw;
  color: #646a6a;
  margin-top: -2.222vh;
}

.parrafo {
  max-width: 30vw;
  font-family: Nunito, sans-serif;
  font-weight: 500;
  font-size: 1.25vw;
  line-height: 2.8vh;
  color: #949a9a;
  margin: 1vh 0 0 0;
}

.imagen {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 56.4vw;
  user-select: none;
  opacity: 0.7;
}

.static_neumobot {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 17.1vw; /*31.5*/
  margin-right: 14.4vw;
  margin-bottom: 13.8vh;
  animation: ArribaAbajo 5s ease-in-out infinite; /* Propiedad de animación CSS */
}

/* Definición de tiempos para animación del bot */
@keyframes ArribaAbajo {
  0%,
  100% {
    bottom: 0;
  }
  50% {
    bottom: 4.6vh;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/Login.vue